import { render, staticRenderFns } from "./ModalHoliday.vue?vue&type=template&id=8a5c9814&"
import script from "./ModalHoliday.vue?vue&type=script&lang=js&"
export * from "./ModalHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports